import { useCallback } from 'react';
import { Dropdown, Form, Row, Col, Button } from 'react-bootstrap';
import { IoIosLink } from 'react-icons/io';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import FormModal from '../../../components/FormModal';
import useDeviceLinks from '../hooks/useDeviceLinks';
import { isValidMacAddress } from '../../../lib/utils';

function AddLinkModal({ device, header, as='dropdown' }) {
  const { t } = useTranslation();

  const { register, handleSubmit, reset, formState } = useForm({
    mode: 'onChange',
    defaultValues: {
      serial: '',
    }
  });
  const { loading: submitting, updateLinks } = useDeviceLinks(device?.id);

  const onSubmit = useCallback(async (data) => {
    const { serial } = data;
    await updateLinks({
      links: [{
        serial, linked: true,
      }]
    });
    reset();
  }, [updateLinks]);

  const renderForm = useCallback(() => {
    return (
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Form.Group as={Row}>
          <Form.Label column sm="3">{t('components.add-link-modal.label')}</Form.Label>
          <Col sm="9">
            <Form.Control
              {...register('serial', {
                required: true,
                validate: value =>{
                  return isValidMacAddress(value) && device.serial.toLowerCase() !== value.toLowerCase();
                }
              })} />
            <Form.Text muted>{t('components.add-link-modal.text')}</Form.Text>
          </Col>
        </Form.Group>
      </Form>
    );
  }, [onSubmit, formState]);

  return (
    <FormModal
      header={header}
      form={renderForm()}
      confirmText={t('components.add-link-modal.confirm-text')}
      size="md"
      valid={!submitting && formState.isValid}
    >
      {as === 'dropdown' ?
        <Dropdown.Item>
          <IoIosLink size="1.2em" /> <span>{header}</span>
        </Dropdown.Item> :
        <Button size="sm" variant="outline-secondary">
          <IoIosLink size="1.2em" /> <span>{header}</span>
        </Button>
      }
    </FormModal>
  );
}

export default AddLinkModal;
